import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import { Col, Row, Upload, Card, Icon, Progress } from 'antd';
import XLSX from 'xlsx';
import { fetchLog, addLog } from 'appRedux/actions/Log';
import convertData from 'firebase/utils/convertData';
import collectDataFromTemplate from 'util/collectDataFromTemplate';
import computePercentFromPromises from 'util/computePercentFromPromises';
import computeRequests from 'util/computeRequests';
import downloadFromUrl from 'util/downloadFromUrl';

const Dragger = Upload.Dragger;

const MigrateData = (props) => {
  const { currentUser, location: { pathname }, dataLog, fetchLog, addLog } = props;
  const convertedDataLog = isEmpty(dataLog) ? [] : convertData(dataLog);
  const [isValidTemplate, setIsValidTemplate] = useState(true);
  const [currentFile, setCurrentFile] = useState('');
  const [percent, setPercent] = useState(0);
  const [files, setFiles] = useState([]);
  const isInProfress = percent > 0 && percent < 100;
  const collectionName = pathname === '/migrate-data-buzz' ? 'buzzs' : 'campaigns';

  const getStatus = () => {
    if (percent === 100) {
      return 'success';
    }
    return 'active';
  }

  const getText = () => {
    if (percent === 100) {
      return <span className="gx-text-success">Xử lý thành công tập tin {currentFile}</span>;
    }
    if (!isValidTemplate) {
      return <span className="gx-text-danger"><Icon type="close-circle" theme="twoTone" twoToneColor="#f44336" />&nbsp;Tập tin {currentFile} không hợp lệ vì không theo template mẫu</span>;
    }
    if (isInProfress) {
      return 'Đang xử lý tập tin...';
    }
    return '';
  }

  const handleDownload = (e) => {
    e.preventDefault();
    const link = collectionName === 'buzzs' ? '/sampleImport/BrandTemplate.xlsx' : '/sampleImport/CampaignTemplate.xlsx';
    const name = collectionName === 'buzzs' ? 'BrandTemplate.xlsx' : 'CampaignTemplate.xlsx'
    downloadFromUrl(link, name);
  }

  const draggerProps = {
    disabled: isInProfress,
    name: 'file',
    multiple: false,
    accept:
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
    onStart(file) {
      setCurrentFile(file.name);
      setIsValidTemplate(true);
      setFiles([...files, file.name]);
      setPercent(0);
    },
    customRequest: ({
        action,
        data,
        file,
        filename,
        headers,
        onError,
        onProgress,
        onSuccess,
        withCredentials,
      }) => {
        var reader = new FileReader();
    
        reader.onload = function(e) {
          const data = e.target.result;
          const workbook = XLSX.read(data, {
            type: 'binary'
          });
    
          const [sheetName] = workbook.SheetNames;
          const template = workbook.Sheets[sheetName];

          const range = XLSX.utils.decode_range(template['!ref']);
          const numRows = range.e.r - range.s.r + 1;

          if (!template) {
            setIsValidTemplate(false);
            return;
          }

          const {
            brands,
            industries,
            categories,
            volumes,
          } = collectDataFromTemplate(template, numRows);

          if (brands.length === 0 || industries.length === 0 || categories.length === 0 || volumes.length === 0) {
            setIsValidTemplate(false);
            return;
          }

          const requests = computeRequests({
            currentUser, template, brands, industries, categories, volumes, collectionName,
          });

          computePercentFromPromises(requests, (percent) => {
            const value = Math.floor(percent);
            setPercent(value);
            setIsValidTemplate(true);
          });
        };
    
        reader.onerror = (e) => {
          setIsValidTemplate(false);
        };
    
        reader.readAsBinaryString(file);

        addLog({
          params: {
            type: 'import',
            action: `import file ${file.name}`,
            user: currentUser,
            time: moment().unix(),
          }
        });
      },
    };
  
  useEffect(() => {
    fetchLog({
      filter: { type: 'import' },
    });
  }, [fetchLog]);

  return (
    <>
      <Row>
        <Col span={24}>
          <Card className="gx-card" title="Nhập dữ liệu từ excel">
            <Dragger {...draggerProps}>
              <p className="ant-upload-drag-icon">
                <Icon type="file-excel" />
              </p>
              <p className="ant-upload-text">Chọn hoặc kéo thả tập tin vào để nhập dữ liệu</p>
              <p className="ant-upload-hint">(Chỉ hỗ trợ định dạng: .xls, .xlsx)</p>
            </Dragger>
            <div className="progress-bar">
              <div>{getText()}</div>
              {percent > 0 && <Progress percent={percent} status={getStatus()} />}
            </div>
            <div>
              <a href='/' onClick={handleDownload} className='gx-text-primary'>
                * Download import template here
              </a>
            </div>
            {convertedDataLog.length > 0 && <div>
              <div className="gx-text-primary">* Recent data import:</div>
              {convertedDataLog.map((log, i) => <div key={`log_${i}`}>- {log.user} {log.action} vào lúc {moment(log.time * 1000).format('DD-MM-YYYY HH:mm:ss')}</div>)}
            </div>
            }
          </Card>
          {files.length > 0 && <div>
            <div className="gx-text-primary">* Tập tin vừa được xử lý ({files.length}):</div>
            {files.map((file, i) => <div key={`file_${i}`}>- {file}</div>)}
          </div>}
        </Col>
      </Row>
    </>
  );
};

const mapStateToProps = ({ auth, log }) => {
  const { currentUser } = auth;
  const { data: dataLog } = log;
  return { currentUser, dataLog };
};

export default connect(
  mapStateToProps,
  { fetchLog, addLog }
)(MigrateData);
